import { Flex } from 'antd';
import CircularPill from 'components/lead-details-common/circularPill';
import StatusButton from 'utils/status/status_button';
import styles from './useTableColumns.module.scss';
import { IF } from 'common';
import Dropdown from 'common/drop-down/DropDown';

const RenderMultiPills = ({ pills, itemToShow = 2 }) => {
  return (
    <Flex wrap gap={4}>
      {pills?.slice(0, itemToShow)?.map((pill, index) => {
        return <StatusButton className="body-12-semibold" isTruncate key={index} status={pill} />;
      })}
      <IF condition={pills?.length - itemToShow > 0}>
        <div className={styles.dropdownWrapper}>
          <Dropdown
            placement={'bottomLeft'}
            triggerMode={['hover']}
            DropDownButton={() => (
              <CircularPill
                value={`+${pills?.length - itemToShow}`}
                size={28}
                color="primary"
                className="body-12-semibold"
              />
            )}
            overlayClassName={styles.dropdownOverlay}
            arrow={{ pointAtCenter: true }}
            dropdownRender={() => (
              <Flex vertical gap={8} className={styles.dropdownContainer}>
                {pills.slice(itemToShow)?.map((pill, idx) => {
                  return (
                    <Flex key={idx} gap={10} align="center">
                      <div style={{ backgroundColor: pill?.color }} className={styles.dot} />
                      <div style={{ color: pill?.color }} className="body-12-semibold">
                        {pill?.name}
                      </div>
                    </Flex>
                  );
                })}
              </Flex>
            )}
          />
        </div>
      </IF>
    </Flex>
  );
};

export default RenderMultiPills;
